import React from "react";
import { BrowserRouter, Route, Routes as RouterRoutes } from "react-router-dom";
import ErrorBoundary from "components/ErrorBoundary";
import ScrollToTop from "components/ScrollToTop";
import NotFound from "pages/NotFound";
import {
  AboutPage, AppraisalPage, BookServicePage, ContactPage, HomePage, LegalPage,
  ServicesPage, TireQuotePage, TiresPage, VehiclePage, VehicleRequestPage,
} from "pages/SitePages";

export default function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<HomePage />} />
          <Route path="/homepage" element={<HomePage />} />
          <Route path="/find-your-vehicle" element={<VehiclePage />} />
          <Route path="/vehicle-request" element={<VehicleRequestPage />} />
          <Route path="/auto-services" element={<ServicesPage />} />
          <Route path="/book-service" element={<BookServicePage />} />
          <Route path="/tires" element={<TiresPage />} />
          <Route path="/tire-quote" element={<TireQuotePage />} />
          <Route path="/appraisal" element={<AppraisalPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
